import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import {Facture} from '../../model/facture';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";

import { SharedMethods } from '../../../../util/sharedMethods-service';
import { isDefined } from '@angular/compiler/src/util';
import { plainToClass } from 'class-transformer';
import { SettingService } from '../setting-service';
import { Commande } from '../../model/commande';
import { FluxStock } from '../../model/fluxstock';
import { Reglement } from '../../model/reglement';
import { Bordereau } from '../../model/bordereau';
import { BehaviorSubject, Subject } from 'rxjs';
import { Taxe } from '../../model/taxe';

@Injectable()
export class FactureService {

  localFacturesVente: Facture[];
  localFacturesAchat: Facture[];
  iSconnecting: boolean = false;

  iSsaving: boolean = false;
  iSgetListing: boolean = false;

  // saveFactureEvent: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  // saveFactureEvent = new Subject<any>();

  invoiceSelected: Facture;


  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              public sharedMethods: SharedMethods,
              private settingService: SettingService,
              ) { }

  getFactures(to: string, from: string, type: string, idpartner: string, paidstatus: string, state: string, livraison: string) {
    this.iSgetListing = true;
    return new Promise<Facture[]>(resolve => {
        this.http.get(this.apiEndpoints.URL_GET_FACTURES(to, from, type, idpartner, paidstatus, state, livraison),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Facture[]) =>  {
              const factures = plainToClass(Facture, data);
              /* for ( let i = 0; i < factures.length; i++) {
                factures[i].fluxstock = plainToClass(FluxStock, factures[i].fluxstock);
                factures[i].reglements = plainToClass(Reglement, factures[i].reglements);
              } */
              this.setLocalFacture(type,  factures);

              resolve(factures);
              this.iSgetListing = false;
            },
            err => {
              // console.log(err);
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              this.iSgetListing = false;
            });
    });

    /* this.http.get(this.apiEndpoints.URL_GET_PRODUITS,
      {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
      .subscribe(data => {
          // resolve(data);
          alert(JSON.stringify(data));
          // alert('ok');
        },
        err => {
          // console.log(err);
          alert(JSON.stringify(err));
    }); */

  }

  getFacture(idfacture: number) {

    this.iSconnecting = true;
    return new Promise<Facture>(resolve => {
        this.http.get(this.apiEndpoints.URL_GET_FACTURE(idfacture),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Facture) =>  {
              const facture = plainToClass(Facture, data as object);
              /* for ( let i = 0; i < factures.length; i++) {
                factures[i].fluxstock = plainToClass(FluxStock, factures[i].fluxstock);
                factures[i].reglements = plainToClass(Reglement, factures[i].reglements);
              } */
              resolve(facture);
              this.iSconnecting = false;
            },
            err => {
              // console.log(err);
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              this.iSconnecting = false;
            });
    });

  }


  saveFacture(facture: Facture, type: string) {
      this.iSsaving = true;

      let id_partner: number;
      if (isDefined(facture.partenaire)) {
        id_partner = facture.partenaire.id;
      } else {
        id_partner = null;
      }
      const fac = {
              dateFacturation: this.sharedMethods.converStringToDatetime(facture.date_facturation),
              nbrJourEcheance: facture.nbr_jour_echeance,
              // dateRetour: this.sharedMethods.converStringToDatetime(facture.date_retour),
              typeFacture: facture.type_facture,
              partenaire: id_partner,
              note: facture.note,
              ref: facture.refgene,
              livrer: facture.livrer,
            };


      if (facture.id !== 0) {

        return new Promise<Facture>(resolve => {
          this.http.put(this.apiEndpoints.GET_URL_PUT_FACTURE(facture.id), fac,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: Facture) => {

                /* resolve(data);
                this.iSsaving = false; */
                this.getFactures(this.settingService.to, this.settingService.from, type, '', '', '', null).then(factures => {
                  resolve(plainToClass(Facture, data as object));
                  this.iSsaving = false;
                });

              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSsaving = false;
              });
        });

      } else {

        return new Promise<Facture>(resolve => {
          this.http.post(this.apiEndpoints.GET_URL_POST_FACTURE, fac,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: Facture) => {
                /* resolve(data);
                this.iSsaving = false; */
                this.getFactures(this.settingService.to, this.settingService.from, type, '', '', '', null).then(factures => {
                  resolve(plainToClass(Facture, data as object));
                  this.iSsaving = false;
                });
              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSsaving = false;
              });
        });

      }


    }


    saveFactureAndFlux(facture: Facture, cmd: Commande[], type: string, valider: boolean, idcompte: number) {

      this.iSsaving = true;

      const fluxStockList = [];

      const commandesList = [];

      // flux livré
      if (cmd !== undefined) {

        for ( let i = 0; i < cmd.length; i++) {

          const flux = {
            copyIdForUpdate: cmd[i].id,
            quantite: cmd[i].quantite,
            prixUnitaire: cmd[i].prix_unitaire,
            produit: cmd[i].produit.id,
            tva: cmd[i].tva,
            typeCalculTva: cmd[i].type_calcul_tva,
            description: cmd[i].description,
            // tva: facture.tva,
            remise: cmd[i].remise,
          };

          commandesList.push(flux);

        }

      }

      // reglement
      const reglementList = [];

      if (facture.reglements !== undefined) {
        for ( let i = 0; i < facture.reglements.length; i++) {

          const reg = {
            copyIdForUpdate: facture.reglements[i].id,
            natureReglement: facture.reglements[i].nature_reglement,
            createBy: null,
            dateFlux: this.sharedMethods.converStringToDatetime(facture.reglements[i].date_flux),
            typeFlux: facture.reglements[i].type_flux,
            montant: facture.reglements[i].montant,
          };

          reglementList.push(reg);

        }
      }

      let id_partner: number;
      if (facture.partenaire !== undefined && facture.partenaire !== null) {
        id_partner = facture.partenaire.id;
      } else {
        id_partner = null;
      }

      let id_resp: number;
      if (facture.resp !== undefined && facture.resp !== null) {
        id_resp = facture.resp.id;
      } else {
        id_resp = null;
      }

      // taxes
      const taxes = []
      if( facture.taxes !== undefined && facture.taxes !== null ) {

        facture.taxes.forEach(element => {
          taxes.push({
            id: element.id,
            designation: element.designation,
            valeur: element.valeur,
            typeCalcul: element.type_calcul,
            isAboutHT: element.is_about_h_t,
          });
  
        });

      }
      
      const fac = {
        dateFacturation: this.sharedMethods.converStringToDatetime(facture.date_facturation),
        repeatDate: this.sharedMethods.converStringToDatetime(facture.repeat_date),
        repeatPeriod: facture.repeat_period,
        nbrJourEcheance: facture.nbr_jour_echeance,
        // dateRetour: this.sharedMethods.converStringToDatetime(facture.date_retour),
        typeFacture: facture.type_facture,
        partenaire: id_partner,
        resp: id_resp,
        note: facture.note,
        ref: facture.ref,
        livrer: facture.livrer,
        payer: facture.payer,
        valider: valider,
        fluxStockList: fluxStockList,
        commandesList: commandesList,
        reglementList: reglementList,
        taxes:taxes,
        nomFacturation: facture.nom_facturation,
        telFacturation: facture.tel_facturation,
        paysFacturation: facture.pays_facturation,
        villeFacturation: facture.ville_facturation,
        adresseFacturation: facture.adresse_facturation,
        bpFacturation: facture.bp_facturation,
      };


      if (facture.id !== 0) {

        return new Promise<Facture>(resolve => {
          this.http.patch(this.apiEndpoints.GET_URL_PATCH_FACTUREANDFLUX(facture.id, idcompte), fac,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: Facture) => {

                resolve(plainToClass(Facture, data as object));
                this.iSsaving = false;
               /*  this.getFactures(type).then(factures => {
                  resolve(plainToClass(Facture, data as object));
                  this.iSsaving = false;
                }); */

              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSsaving = false;
              });
        });

      } else {

        return new Promise<Facture>(resolve => {
          this.http.post(this.apiEndpoints.GET_URL_POST_FACTUREANDFLUX(idcompte), fac,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: Facture) => {
                resolve(plainToClass(Facture, data as object));
                this.iSsaving = false;
               /*  this.getFactures(type).then(factures => {
                  resolve(data);
                  this.iSsaving = false;
                }); */
              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSsaving = false;
              });
        });

      }


    }



    deleteFacture(facture: Facture, type: string) {

      this.iSconnecting = true;

      return new Promise(resolve => {
        this.http.delete(this.apiEndpoints.GET_URL_DELETE_FACTURE(facture.id),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe(data => {

              resolve(data);
              /* this.getFactures(this.settingService.to, this.settingService.from, type, '', '', '').then(factures => {
                resolve(data);
                this.iSconnecting = false;
              }); */

              this.iSconnecting = false;

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });


    }

    setLocalFacture(type: string, factures: Facture[]) {
      if (type === 'vente')
      this.localFacturesVente = factures ;

      if (type === 'achat')
      this.localFacturesAchat = factures;
    }

    getLocalFacture(type: string) {
      if (type === 'vente')
      return this.localFacturesVente;

      if (type === 'achat')
      return this.localFacturesAchat;
    }


    cmdByProd( idproduit: number, cmd: Commande[] ): Commande {

        let result: Commande;

        if ( cmd !== null && cmd !== undefined) {


            for ( let i = 0; i < cmd.length; i++) {

                if (cmd[i].produit.id === idproduit)
                result = cmd[i];

            }


        }

        return result;

    }

    montantHT(cmd: Commande[]): number {

        let total = 0;

        if (cmd !== undefined) {


            for ( let i = 0; i < cmd.length; i++) {

                total += cmd[i].prixHT;

            }

        }

        return total;

    }

    montantTVA(cmd: Commande[]): number {

        let total = 0;

        if (cmd !== undefined) {

            for ( let i = 0; i < cmd.length; i++) {

                total += cmd[i].montantTVA;

            }

        }

        return total;
    }



    quantiteCommande(cmd: Commande[]): number {

      let total = 0;

      if ( cmd !== null && cmd !== undefined) {


          for ( let i = 0; i < cmd.length; i++) {

              total += cmd[i].quantite;

          }


      }

      return total;

    }

    qteCmdByProd( idproduit: number, cmd: Commande[] ): number {

        let total = 0;

        if ( cmd !== null && cmd !== undefined) {

            for ( let i = 0; i < cmd.length; i++) {

                if (cmd[i].produit.id === idproduit)
                total += cmd[i].quantite;

            }

        }

        return total;

    }

    remise(cmd: Commande[]): number {

        let total = 0;

        if (cmd !== undefined) {


            for ( let i = 0; i < cmd.length; i++) {

                if (cmd[i].remise !== undefined)
                total += cmd[i].remise;

            }

        }

        return total;

    }


    montantSansLesRetours(cmd: Commande[]): number {

       

        let total = 0;

        if (cmd !== undefined) {


            for ( let i = 0; i < cmd.length; i++) {

                total += cmd[i].prixHT + cmd[i].montantTVA;

            }

        }

        return total;

    }

    montantLivraison(bordereauxLivraison: Bordereau[]): number {

        let flux: FluxStock[];

        flux = [];
        if ( bordereauxLivraison !== undefined && bordereauxLivraison !== null) {
            for ( let i = 0; i < bordereauxLivraison.length; i++) {

                for ( let i2 = 0; i2 < bordereauxLivraison[i].fluxstock.length; i2++) {
                    flux.push(bordereauxLivraison[i].fluxstock[i2]);
                }

            }
        }

        let total = 0;

        const classfluxstock = plainToClass(FluxStock, flux);

        for ( let i = 0; i < classfluxstock.length; i++) {

            total += classfluxstock[i].prixTotal;

        }


        return total;

    }

    quantiteLivrer(bordereauxLivraison: Bordereau[]): number {

        let total = 0;

        if ( bordereauxLivraison !== null && bordereauxLivraison !== undefined) {

            for ( let i = 0; i < bordereauxLivraison.length; i++) {

                total += bordereauxLivraison[i].quantiteLivrer;

            }

        }

        return total;

    }

    montantRetour(bordereauxRetour: Bordereau[]): number {

        let flux: FluxStock[];

        flux = [];

        if (bordereauxRetour !== undefined && bordereauxRetour.length !== null) {

            for ( let i = 0; i < bordereauxRetour.length; i++) {

                for ( let i2 = 0; i2 < bordereauxRetour[i].fluxstock.length; i2++) {
                    flux.push(bordereauxRetour[i].fluxstock[i2]);
                }

            }

        }

        const classflux = plainToClass(FluxStock, flux);

        let total = 0;

        for ( let i = 0; i < classflux.length; i++) {

            total += classflux[i].prixTotal;

        }

        return total;

    }

    quantiteRetour(bordereauxRetour: Bordereau[]): number {

        let total = 0;

        if (bordereauxRetour !== null && bordereauxRetour !== undefined) {


            for ( let i = 0; i < bordereauxRetour.length; i++) {

                total += bordereauxRetour[i].quantiteLivrer;

            }

        }

        return total;

    }

    montantReglement(reglements: Reglement[]): number {

        let paye = 0;

        if (reglements !== undefined ) {


            for ( let i = 0; i < reglements.length; i++) {

                // if (classreglement[i] !== null)
                paye += reglements[i].montant;

            }

        }

        return paye;
    }

    /* montant(cmd: Commande[], bordereauxRetour: Bordereau[]): number {

        return this.montantSansLesRetours(cmd) - this.montantRetour(bordereauxRetour);

    } */
  
    montantTaxe(taxe: Taxe, montantHTSansEmballage: number, montantTTCSansEmballage: number, quantiteProduit: number): number {

      if (taxe.valeur === null || taxe.valeur === undefined)
      return 0;

      if( taxe.type_calcul === 'pourcentage') {

          if (Number(taxe.is_about_h_t)) {

              return ( montantHTSansEmballage * Number(taxe.valeur)) / 100;
  
          } else {
  
              return ( montantTTCSansEmballage * Number(taxe.valeur)) / 100;
          }

      } else {

              return quantiteProduit * Number(taxe.valeur);
      }

      // return 10;

    }

  qteEmballage(commandeEmballage: Commande[]): number {

      let total = 0;

      for ( let i = 0; i < commandeEmballage.length; i++) {

          total += commandeEmballage[i].quantite;

      }

      return total;

  }

  montantEmballage(commandeEmballage: Commande[]): number {

      let total = 0;

      for ( let i = 0; i < commandeEmballage.length; i++) {

          total += commandeEmballage[i].prixHT;

      }

      return total;

  }

  commandeEmballage( commandes: Commande[]): Commande[] {

      let total = [];

      if (commandes !== undefined) {

          const classCommandes = plainToClass(Commande, commandes);

          for ( let i = 0; i < classCommandes.length; i++) {
              if( classCommandes[i].produit.is_emballage )
              total.push( classCommandes[i] );

          }

      }

      return total;

  }


}
